import { render, staticRenderFns } from "./NetgearRouter.vue?vue&type=template&id=44509c9a&scoped=true&"
import script from "./NetgearRouter.vue?vue&type=script&lang=js&"
export * from "./NetgearRouter.vue?vue&type=script&lang=js&"
import style0 from "./NetgearRouter.vue?vue&type=style&index=0&id=44509c9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44509c9a",
  null
  
)

export default component.exports